import logo from "./logo-view";

export default logo;
